/* eslint react/prop-types:0 */
import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { LoadablePaint } from '@confluence/loadable';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';
import { useBooleanFeatureFlag } from '@confluence/session-data';

const AdvancedSearchPage = LoadablePaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-AdvancedSearchPage" */ '../../AdvancedSearchPage'),
});

export const AdvancedSearchRoute = () => {
	const isFullPageSearchEnabled = useBooleanFeatureFlag(
		'confluence.frontend.advanced.search.unified.full.page',
	);

	return (
		<Screen
			{...(!isFullPageSearchEnabled && {
				screenEvent: { name: 'advancedSearchScreen' },
			})}
		>
			<MainLayout navView={PRODUCT_HOME_ID}>
				<AdvancedSearchPage />
			</MainLayout>
		</Screen>
	);
};
